<template lang="pug">
  app-modal(v-model="value.isOpen", type="default", size="large" data-testid="bcard-data-modal")
    template(slot="title") 名刺情報
    .bcard-btnbar.text-right
      router-link(v-if="needMoreLink", target="_blank", :to="{name: 'box-detail', params: {sidPerson: value.sidPerson}}" data-testid="-link-view-data") すべての情報を見る
        |
        |
        i.fa.fa-external-link
    card-view(:bcard="bcard")
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import CardView from '@/components/organisms/views/CardView'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PersonRepository = RepositoryFactory.get('person')

export default {
  name: 'ModalBcard',
  components: { AppModal, CardView },
  props: {
    /**
     * isOpen
     * sidBcard: 名刺IDを指定する場合、必須
     * sidPerson: 人物IDの最新名刺を取得する場合、必須
     */
    value: { type: Object, required: true },
    /**
     * 「すべての情報を見る」リンクを出すかどうか
     */
    needMoreLink: { type: Boolean, required: false, default: true }
  },
  data () {
    return {
      bcard: {}
    }
  },
  watch: {
    'value.isOpen' (isOpen) {
      if (isOpen) {
        this.getData()
      }
    }
  },
  methods: {
    getData () {
      // データを初期表示しておく
      this.bcard = {}

      const sidPerson = this.value.sidPerson
      const sidBcard = this.value.id
      const method = sidBcard ? 'getBcard' : 'getLatestBcard'
      // TODO [次期]リファクタリング
      const secondParam = sidBcard || this.isMgmt

      // DBからリアルタイムのデータを取得する
      const vm = this
      PersonRepository[method](sidPerson, secondParam, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.bcard = data
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '名刺履歴の詳細情報が取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/ModalBcard.vue